import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import {Moment} from "moment";
import {GetPurchaseInvoiceListDto} from "../model/invoice/purchase/GetPurchaseInvoiceListDto";
import FetchPurchaseInvoicesForReviewResponse from "../model/invoice/purchase/FetchPurchaseInvoicesForReviewResponse";
import {AsyncTaskStatus} from "../model/AsyncTask";
import {formatMonth} from "../utils/DataFormat";
import {ResultOrErrorDto} from "../model/ResultOrErrorDto";

class PurchaseInvoiceApi {

    public fetchInvoices(from: Moment, to: Moment): Promise<GetPurchaseInvoiceListDto[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/purchase?from=${Backend.date(from)}&to=${Backend.date(to)}`);
    }

    public deleteInvoice(invoiceId: string): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.delete(`/api/v1/company/${companyId}/invoice/purchase/${invoiceId}`);
    }

    public startReviewGeneration(month: Moment): Promise<string> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/invoice/purchase/review`, {month: formatMonth(month)});
    }

    public fetchReviewStatus(taskId: string): Promise<AsyncTaskStatus> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/purchase/review/${taskId}/status`);
    }

    public fetchReviewResult(taskId: string): Promise<ResultOrErrorDto<FetchPurchaseInvoicesForReviewResponse>> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/purchase/review/${taskId}/result`);
    }
}

export const purchaseInvoiceApi = new PurchaseInvoiceApi();